<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">


  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
      <!--      <button class="mb-1" color="primary" mat-button>-->
      <!--        New file-->
      <!--      </button>-->
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <!--      (matSortChange)="doSortFiles($event)"-->
    <table [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table matSort multiTemplateDataRows>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
        <td *matCellDef="let element" mat-cell> {{element.name}} </td>
      </ng-container>

      <!-- Last change Column -->
      <ng-container matColumnDef="lastModified">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Last change</th>
        <td *matCellDef="let element" mat-cell> {{element.lastModified | date:'dd/MM/yyyy hh:mm'}} </td>
      </ng-container>

      <!-- Size Column -->
      <ng-container matColumnDef="size">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Size</th>
        <td *matCellDef="let element" mat-cell> {{element.size | bytes}}</td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell>
          <!--          <ng-container *ngIf="downloadingProgress[element.name]">-->

          <!--          </ng-container>-->
          <ng-container *ngIf="!disabledItemsIds.includes(element.name); else loadingItem">
            <div fxLayout="row" fxLayoutAlign="end center">
              <mat-spinner *ngIf="downloadingProgress[element.name] != undefined" [diameter]="20"
                [value]="downloadingProgress[element.name]" color="primary" mode="indeterminate"></mat-spinner>
              <!--                           [mode]="downloadingProgress[element.name] == undefined || downloadingProgress[element.name] == 0 ? 'indeterminate' : 'determinate'"-->
              <button (click)="download(element)" *ngIf="downloadingProgress[element.name] == undefined" mat-icon-button
                matTooltip="Download file">
                <mat-icon>download</mat-icon>
              </button>

              <button color="warn" mat-icon-button (click)="deleteFile(element)" *ngIf="canIDeleteFile(element)"
                matTooltip="Delete file">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </ng-container>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>

      <tr *matNoDataRow>
        <td [colSpan]="displayedColumns.length" class="text-center">
          No files found
        </td>
      </tr>

    </table>

  </ng-container>

  <mat-paginator #paginatorTestbeds [fxShow]="dataSource && dataSource.data.length > 10" [pageSizeOptions]="[5, 10, 20]"
    [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
</div>